import React from 'react'
import { ListingFilter, ListingFrameworksFilter, ListingSearchInput, StyledListingSidebar } from '~components/Listing'
import { FILTER_SECTIONS, FilterParam } from './ProjectsList.consts'

interface ComponentProps {
  searchValue: string
  onSearchChange: (value: string) => void
  getSelectedFilter: (paramName: FilterParam) => string[] | undefined
  onFilterChange: (param: FilterParam, values: string[]) => void
}

const ProjectsListSidebar: React.FC<ComponentProps> = ({ searchValue, onSearchChange, getSelectedFilter, onFilterChange }) => (
  <StyledListingSidebar.Sidebar>
    <StyledListingSidebar.SearchInput>
      <ListingSearchInput defaultValue={searchValue} onChange={onSearchChange} placeholder="Search for projects" />
    </StyledListingSidebar.SearchInput>

    <ListingFilter<FilterParam> sections={FILTER_SECTIONS} getSelectedFilter={getSelectedFilter} onChange={onFilterChange}>
      <ListingFrameworksFilter name={FilterParam.framework} getSelectedFilter={getSelectedFilter} onChange={onFilterChange} />
    </ListingFilter>
  </StyledListingSidebar.Sidebar>
)

export default ProjectsListSidebar
